<template>
  <div class="container">
    <div class="columns box-title is-12">
      <div class="column is-6">
        <h4 class="has-text-left">
          <i class="fal fa-box-check"></i>
          ລາຍການຢືນຢັນຮັບພັດສະດຸ
          <span class="countTotal">({{ ListItems.length }})</span>
        </h4>
      </div>
    </div>

    <div v-if="isDemoMode" class="demo-banner">
      <i class="fal fa-flask"></i>
      <span>
        <strong>ໂໝດທົດລອງ (Demo)</strong> — ຍັງບໍ່ມີ API ສຳລັບໜ້ານີ້,
        ຂໍ້ມູນທັງໝົດເປັນຕົວຢ່າງ ແລະ ຖືກເກັບໄວ້ໃນເຄື່ອງ (localStorage)
      </span>
      <button class="demo-reset" @click="onResetDemo">
        <i class="fal fa-undo"></i> ຣີເຊັດຂໍ້ມູນທົດລອງ
      </button>
    </div>

    <!-- ສະຫຼຸບຕາມສະຖານະ -->
    <div class="summary-row">
      <div
          v-for="s in summary"
          :key="s.id"
          class="summary-card"
          :class="[s.cls, { 'is-active': searchStatus === s.id }]"
          @click="onToggleStatus(s.id)">
        <i :class="s.icon"></i>
        <div class="summary-text">
          <span class="summary-count">{{ s.count }}</span>
          <span class="summary-label">{{ s.name }}</span>
        </div>
      </div>
    </div>

    <div class="box">
      <div class="columns" style="display: flex; flex-wrap: wrap">
        <div class="column is-3">
          <div class="control">
            <label class="label">ຄົ້ນຫາເລກພັດສະດຸ :</label>
            <input
                class="input"
                type="text"
                name="searchItem"
                v-model="searchItem"
                placeholder="ເລກພັດສະດຸ / ຊື່ຜູ້ຮັບ.."
            />
          </div>
        </div>

        <div class="column is-2">
          <div class="control">
            <label class="label">ຈາກວັນທີ</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                :clearable="true"
                name="start_date"
                v-model="start_date"
            ></date-picker>
          </div>
        </div>

        <div class="column is-2">
          <div class="control">
            <label class="label">ຫາວັນທີ</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                :clearable="true"
                name="end_date"
                v-model="end_date"
            ></date-picker>
          </div>
        </div>

        <div class="column is-2">
          <div class="control">
            <label class="label">ສາຂາຕົ້ນທາງ:</label>
            <div class="select">
              <select class="input" v-model="searchStartBranch">
                <option value="">ທັງໝົດ</option>
                <option v-for="b in startBranches" :key="b" :value="b">{{ b }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="column is-2">
          <div class="control">
            <label class="label">ສາຂາປາຍທາງ:</label>
            <div class="select">
              <select class="input" v-model="searchEndBranch">
                <option value="">ທັງໝົດ</option>
                <option v-for="b in endBranches" :key="b" :value="b">{{ b }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="column is-2">
          <div class="control">
            <label class="label">ສະຖານະ:</label>
            <div class="select">
              <select class="input" v-model="searchStatus">
                <option value="">ທັງໝົດ</option>
                <option v-for="s in statusList" :key="s.id" :value="s.id">{{ s.name }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="column is-3" style="margin-top: 22px">
          <vs-button dark flat @click="onClearFilter">
            <span style="margin-right: 8px"><i class="fal fa-eraser"></i></span>
            ລ້າງການກັ່ນຕອງ
          </vs-button>
        </div>
      </div>
    </div>

    <div class="center fit-width">
      <vs-table ref="table">
        <template #thead>
          <vs-tr>
            <vs-th>ລຳດັບ</vs-th>
            <vs-th>ຮູບພາບ</vs-th>
            <vs-th>ເລກພັດສະດຸ</vs-th>
            <vs-th>ສາຂາຕົ້ນທາງ</vs-th>
            <vs-th>ສາຂາປາຍທາງ</vs-th>
            <vs-th>ສະຖານະ</vs-th>
            <vs-th>ວັນ/ເດືອນ/ປີ</vs-th>
            <vs-th>ຈັດການ</vs-th>
          </vs-tr>
        </template>

        <template #tbody>
          <vs-tr
              :key="index"
              :data="item"
              v-for="(item, index) in $vs.getPage(ListItems, page, max)">
            <vs-td>{{ (page - 1) * max + index + 1 }}</vs-td>

            <!-- ຮູບພາບ (ກົດເບິ່ງໄດ້) -->
            <vs-td>
              <div class="thumb-wrap" v-if="item.images && item.images.length"
                   @click="openLightbox(item, 0)">
                <img class="thumb" :src="item.images[0].image_url" :alt="item.parcel_number"/>
                <span class="thumb-zoom"><i class="fal fa-search-plus"></i></span>
                <span class="thumb-count" v-if="item.images.length > 1">
                  <i class="fal fa-images"></i> {{ item.images.length }}
                </span>
              </div>
              <span v-else class="no-image"><i class="fal fa-image-slash"></i> ບໍ່ມີຮູບ</span>
            </vs-td>

            <vs-td>
              <span class="parcel-no">{{ item.parcel_number }}</span>
            </vs-td>

            <vs-td>
              {{ item.start_branch.name }}
              <span class="prov">{{ item.start_branch.province.prefix }}</span>
            </vs-td>

            <vs-td>
              {{ item.end_branch.name }}
              <span class="prov">{{ item.end_branch.province.prefix }}</span>
            </vs-td>

            <vs-td>
              <div class="status-pill" :class="statusMeta(item.status).cls">
                <i :class="statusMeta(item.status).icon"></i>
                {{ statusMeta(item.status).name }}
              </div>
            </vs-td>

            <vs-td>{{ formatDateTime(item.created_at) }}</vs-td>

            <!-- ດວງຕາ → ເບິ່ງລາຍລະອຽດ -->
            <vs-td style="text-align: center">
              <div class="group-icon">
                <vs-button circle icon flat success @click="viewDetail(item.id)">
                  <i class="fad fa-eye"></i>
                </vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>

        <template #footer>
          <vs-pagination v-model="page" :length="$vs.getLength(ListItems, max)"/>
          <Loading v-if="isLoading"/>
        </template>
      </vs-table>

      <div v-if="!isLoading && !ListItems.length" class="empty-state">
        <i class="fal fa-inbox"></i>
        <p>ບໍ່ພົບຂໍ້ມູນຕາມເງື່ອນໄຂທີ່ເລືອກ</p>
      </div>
    </div>

    <!-- ==================== Lightbox ເບິ່ງຮູບ ==================== -->
    <div v-if="lightbox.open" class="lightbox" @click.self="closeLightbox">
      <button class="lb-close" @click="closeLightbox"><i class="fal fa-times"></i></button>

      <button
          class="lb-nav lb-prev"
          v-if="lightbox.images.length > 1"
          @click.stop="prevImage">
        <i class="fal fa-chevron-left"></i>
      </button>

      <div class="lb-content" @click.stop>
        <img :src="currentImage.image_url" :alt="lightbox.title"/>
        <div class="lb-caption">
          <strong>{{ lightbox.title }}</strong>
          <span>{{ currentImage.caption }}</span>
          <span class="lb-index">{{ lightbox.index + 1 }} / {{ lightbox.images.length }}</span>
        </div>
      </div>

      <button
          class="lb-nav lb-next"
          v-if="lightbox.images.length > 1"
          @click.stop="nextImage">
        <i class="fal fa-chevron-right"></i>
      </button>

      <div class="lb-strip" v-if="lightbox.images.length > 1" @click.stop>
        <img
            v-for="(img, i) in lightbox.images"
            :key="img.id"
            :src="img.image_url"
            :class="{ active: i === lightbox.index }"
            @click="lightbox.index = i"/>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/views/Loading";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import router from "@/router";
import {
  DEMO_ENABLED,
  filterReceiveParcels,
  getBranchOptions,
  getReceiveStatuses,
  getStatusMeta,
  getStatusSummary,
  resetDemoStore,
} from "@/views/SuperAdmin/ConfirmReceiveParcel/demoData";

export default {
  components: {Loading, DatePicker},

  data: () => ({
    page: 1,
    max: 10,
    isLoading: true,
    isDemoMode: false,

    ListItems: [],
    statusList: [],
    summary: [],
    startBranches: [],
    endBranches: [],

    searchItem: "",
    searchStatus: "",
    searchStartBranch: "",
    searchEndBranch: "",
    start_date: "",
    end_date: "",

    lightbox: {
      open: false,
      images: [],
      index: 0,
      title: "",
    },
  }),

  computed: {
    currentImage() {
      return this.lightbox.images[this.lightbox.index] || {};
    },
  },

  watch: {
    searchItem() {
      this.FetchData();
    },
    searchStatus() {
      this.FetchData();
    },
    searchStartBranch() {
      this.FetchData();
    },
    searchEndBranch() {
      this.FetchData();
    },
    start_date() {
      this.FetchData();
    },
    end_date() {
      this.FetchData();
    },
  },

  methods: {
    statusMeta(id) {
      return getStatusMeta(id);
    },

    formatDateTime(date) {
      return date ? moment(date).format("DD/MM/YYYY HH:mm") : "----";
    },

    viewDetail(id) {
      router.push({name: "confirmReceiveParcel.detail", params: {id: id}}).catch(() => {
      });
    },

    onToggleStatus(id) {
      this.searchStatus = this.searchStatus === id ? "" : id;
    },

    onClearFilter() {
      this.searchItem = "";
      this.searchStatus = "";
      this.searchStartBranch = "";
      this.searchEndBranch = "";
      this.start_date = "";
      this.end_date = "";
    },

    onResetDemo() {
      resetDemoStore();
      this.FetchData();
    },

    // ---------------- lightbox ----------------
    openLightbox(item, index) {
      this.lightbox = {
        open: true,
        images: item.images || [],
        index: index || 0,
        title: item.parcel_number,
      };
      document.body.style.overflow = "hidden";
    },
    closeLightbox() {
      this.lightbox.open = false;
      document.body.style.overflow = "";
    },
    nextImage() {
      this.lightbox.index = (this.lightbox.index + 1) % this.lightbox.images.length;
    },
    prevImage() {
      const len = this.lightbox.images.length;
      this.lightbox.index = (this.lightbox.index - 1 + len) % len;
    },
    onKeydown(e) {
      if (!this.lightbox.open) return;
      if (e.key === "Escape") this.closeLightbox();
      if (e.key === "ArrowRight") this.nextImage();
      if (e.key === "ArrowLeft") this.prevImage();
    },

    // ---------------- data ----------------
    // ເມື່ອ backend ພ້ອມ: ປ່ຽນ body ຂອງ method ນີ້ໄປເອີ້ນ
    // this.$http.get('confirm-receive-parcel', { params: {...} }) ແທນ
    fetchItem() {
      return Promise.resolve(
          filterReceiveParcels({
            search: this.searchItem,
            status: this.searchStatus,
            start_branch: this.searchStartBranch,
            end_branch: this.searchEndBranch,
            start_date: this.start_date,
            end_date: this.end_date,
          })
      );
    },

    FetchData() {
      this.isLoading = true;
      this.fetchItem()
          .then((list) => {
            this.ListItems = list;
            this.summary = getStatusSummary();
            this.isDemoMode = DEMO_ENABLED;
            const maxPage = Math.max(1, Math.ceil(list.length / this.max));
            if (this.page > maxPage) this.page = 1;
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
  },

  created() {
    this.statusList = getReceiveStatuses();
    this.startBranches = getBranchOptions("start_branch");
    this.endBranches = getBranchOptions("end_branch");
    this.FetchData();
  },

  mounted() {
    window.addEventListener("keydown", this.onKeydown);
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeydown);
    document.body.style.overflow = "";
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin-top: 40px;
}

.fit-width {
  white-space: nowrap;
}

.countTotal {
  color: #888;
  font-size: 15px;
}

.label {
  margin-right: 10px;
  margin-top: 2px;
}

/* ---------------- summary cards ---------------- */
.summary-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin: 12px 0;
}

.summary-card {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 180px;
  padding: 12px 18px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #e6e9ef;
  border-left: 5px solid #b0b0b0;
  cursor: pointer;
  transition: all .15s ease;

  i {
    font-size: 22px;
    color: #8a8f99;
  }

  &:hover {
    box-shadow: 0 4px 14px rgba(0, 0, 0, .08);
    transform: translateY(-1px);
  }

  &.is-active {
    box-shadow: 0 4px 14px rgba(0, 0, 0, .12);
    background: #f7f9ff;
  }

  &.st-pending {
    border-left-color: #f39c12;

    i {
      color: #f39c12;
    }
  }

  &.st-checking {
    border-left-color: #0652DD;

    i {
      color: #0652DD;
    }
  }

  &.st-confirmed {
    border-left-color: #009432;

    i {
      color: #009432;
    }
  }

  &.st-rejected {
    border-left-color: #e21312;

    i {
      color: #e21312;
    }
  }
}

.summary-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.summary-count {
  font-size: 20px;
  font-weight: 700;
  color: #333;
}

.summary-label {
  font-size: 13px;
  color: #7a7f88;
}

/* ---------------- table ---------------- */
::v-deep .vs-table__td,
::v-deep .vs-table__th {
  vertical-align: middle !important;
  white-space: nowrap !important;
}

.parcel-no {
  font-weight: 600;
  letter-spacing: .4px;
}

.prov {
  display: inline-block;
  margin-left: 4px;
  padding: 1px 6px;
  border-radius: 8px;
  background: #eef1f5;
  color: #667;
  font-size: 11px;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 12px;
  border-radius: 30px;
  color: #fff;
  font-size: 13px;
  letter-spacing: .5px;
  white-space: nowrap;
  background: #b0b0b0;

  i {
    font-size: 12px;
  }

  &.st-pending {
    background: #f39c12;
  }

  &.st-checking {
    background: #0652DD;
  }

  &.st-confirmed {
    background: #009432;
  }

  &.st-rejected {
    background: #e21312;
  }
}

/* ---------------- thumbnail ---------------- */
.thumb-wrap {
  position: relative;
  width: 64px;
  height: 48px;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #e3e6ec;
  background: #f4f5f7;

  .thumb {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform .2s ease;
  }

  .thumb-zoom {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, .45);
    color: #fff;
    font-size: 16px;
    opacity: 0;
    transition: opacity .2s ease;
  }

  .thumb-count {
    position: absolute;
    right: 3px;
    bottom: 3px;
    padding: 0 5px;
    border-radius: 8px;
    background: rgba(0, 0, 0, .65);
    color: #fff;
    font-size: 10px;

    i {
      font-size: 9px;
    }
  }

  &:hover {
    .thumb {
      transform: scale(1.08);
    }

    .thumb-zoom {
      opacity: 1;
    }
  }
}

.no-image {
  color: #b0b4bb;
  font-size: 12px;
}

.empty-state {
  padding: 50px 0;
  text-align: center;
  color: #9aa0a8;

  i {
    font-size: 46px;
    display: block;
    margin-bottom: 10px;
  }
}

/* ---------------- lightbox ---------------- */
.lightbox {
  position: fixed;
  inset: 0;
  z-index: 100000;
  background: rgba(0, 0, 0, .88);
  display: flex;
  align-items: center;
  justify-content: center;
}

.lb-content {
  max-width: 78vw;
  max-height: 78vh;
  text-align: center;

  img {
    max-width: 78vw;
    max-height: 68vh;
    border-radius: 8px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, .5);
    background: #fff;
  }
}

.lb-caption {
  margin-top: 12px;
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: 14px;

  span {
    color: #cfd3da;
  }

  .lb-index {
    color: #8d949e;
    font-size: 12px;
  }
}

.lb-close {
  position: absolute;
  top: 20px;
  right: 26px;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, .12);
  color: #fff;
  font-size: 20px;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, .25);
  }
}

.lb-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, .12);
  color: #fff;
  font-size: 22px;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, .25);
  }
}

.lb-prev {
  left: 24px;
}

.lb-next {
  right: 24px;
}

.lb-strip {
  position: absolute;
  bottom: 18px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;

  img {
    width: 62px;
    height: 46px;
    object-fit: cover;
    border-radius: 5px;
    opacity: .5;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all .15s ease;

    &.active,
    &:hover {
      opacity: 1;
      border-color: #fff;
    }
  }
}

/* ---------------- demo banner ---------------- */
.demo-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  margin: 10px 0;
  background: linear-gradient(135deg, #fff8e1 0%, #fff3c4 100%);
  border-left: 4px solid #f39c12;
  border-radius: 6px;
  color: #7a5d00;
  font-size: 13px;

  i {
    font-size: 18px;
    color: #f39c12;
  }

  .demo-reset {
    margin-left: auto;
    padding: 5px 12px;
    border: 1px solid #f39c12;
    border-radius: 6px;
    background: #fff;
    color: #b8770a;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;

    i {
      font-size: 12px;
      color: #b8770a;
      margin-right: 4px;
    }

    &:hover {
      background: #fff3c4;
    }
  }
}
</style>
